import { compact } from '../../../../helpers/compact';
import { FooterCardType } from '../../custom-types/footer';
import { toLink, toText } from '../../fields';
import { Link } from '../../fields/link';
import { toIcon } from '../../mapping';

const iconCardsContainer = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): IconCardsContainer | undefined => {
  const tiles = data?.items.map(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (item: Record<string, any>): IconCardsContainerTile => {
      const title = toText(item?.title);
      const description = toText(item?.description);
      const icon = toIcon(item?.icon);
      const ctaLabel = toText(item?.ctaLabel);
      const ctaLink = toLink(item?.ctaLink);

      if (!title || !icon || !ctaLabel || !ctaLink) {
        return undefined;
      }

      return {
        title,
        description,
        icon,
        ctaLabel,
        ctaLink,
      };
    }
  );

  return compact({
    type: FooterCardType.ICON,
    tiles,
  });
};

export type IconCardsContainerTile = {
  title: string;
  description?: string;
  icon: string;
  ctaLabel: string;
  ctaLink: Link;
};

export type IconCardsContainer = {
  type: string;
  tiles: IconCardsContainerTile[];
};

export default iconCardsContainer;
